module.exports = __webpack_public_path__ + "static/media/footer_last.c57aa7c3.jpg";